
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ModelMixin from '@/mixins/ModelMixin';
import LoadableMixin from '@/mixins/LoadableMixin';
import { unixToReadableDate } from '@/utils/datetime';
import { centsToUsd } from '@/utils/amount';
import { getCurrencySymbol } from '@/utils/currency';
import { defaultCurrency } from '@/constants/currency';

@Component({
    components: {},
    mixins: [ModelMixin],
})
export default class PaymentInvoicePopup extends Mixins<LoadableMixin, ModelMixin<boolean>>(LoadableMixin, ModelMixin) {
    @Prop({ required: true })
    invoice!: any;

    defaultCurrency = defaultCurrency;
    unixToReadableDate = unixToReadableDate;
    tableLoading = false;
    centsToUsd = centsToUsd;
    getCurrencySymbol = getCurrencySymbol;

    getTaxAmount(percentage: number) {
        return (this.invoice?.subtotal / 100) * percentage;
    }
}
